import React from 'react'
import { bool, node, oneOf, string } from 'prop-types'
import classNames from 'classnames'

import styles from './Hide.module.scss'

export const widths = ['desktop', 'desktopmedium', 'desktoplarge', 'desktopnav']

const Hide = ({ as, at, below, children, className, offsetByOne }) => {
  const HideEl = as

  return (
    <HideEl
      as={as}
      className={classNames(
        styles.Hide,
        at && styles[`at-${at}${offsetByOne ? '-plus-one' : ''}`],
        below && styles[`below-${below}${offsetByOne ? '-plus-one' : ''}`],
        className
      )}
    >
      {children}
    </HideEl>
  )
}

Hide.defaultProps = {
  as: 'div'
}

Hide.propTypes = {
  as: string,
  at: oneOf(widths),
  below: oneOf(widths),
  children: node,
  className: string,
  offsetByOne: bool
}

export default Hide
